/**
 * 风格状态
 */
export enum StyleStatus {
  DISABLED = 0, // 失效
  ENABLED = 1, // 生效
}

/**
 * 模型编号
 */
export enum ModelNumber {
  MODEL_1_0 = 3, // 1.0
  MODEL_X = 5, // x
  MODEL_3_0 = 7, // 3.0
}

/**
 * 子模型类型（当 model === 5 时使用）
 */
export enum ModelType {
  FLUX = 1,
  SDXL = 2,
}

/**
 * 搜索表单数据
 */
export interface StyleSearchParams {
  pageNum?: number;
  pageSize?: number;
  styleName?: string;
}

/**
 * 风格记录（API 响应）
 */
export interface StyleRecord {
  styleId?: number;
  styleName: string;
  styleNameJa: string;
  styleOrder: number;
  styleImage: string;
  status: StyleStatus;
  description: string;
  descriptionJa: string;
  limitTime: number; // 是否期间限定(1:是0:否)
  model: number | string; // 模型编号（详情可能为数字或字符串，与 /artworkAiDrawStyle/models 一致用字符串匹配展示）
  isSelfStyle: number; // 是否自定义风格 1是 0否
  styleTypeId: number; // 风格类型id
  defaultSelected: number; // 是否选中 1是 0否
  modelNameSuffix?: string; // 模型名称后缀
  modelType?: number; // 子模型：1-flus，2-sdxl（仅 model===5 时有效）
  isRecommend?: number; // 是否推荐
  recommendSort?: number; // 推荐排序
  workFlowJson?: string; // 工作流json
  pixel: number;
  gcoins?: number; // 充值金币
  pcoins?: number; // 活动金币
  isVipStyle?: number; // 是否会员风格
  minTierLevel?: number; // E15: 最低会员等级 -1=Free, 2=Lite, 0=Pro, 1=Premium
  supportStep?: number; // 是否支持细化 0=否 1=是
  stepMin?: number;
  stepMax?: number;
  stepDefault?: number;
  support4k?: number; // 是否支持4K
  supportLora?: number; // 是否支持Lora权重
  supportInpaint?: number; // 是否支持局部重绘
  inpaintWorkflowId?: string; // 重绘工作流ID
  createTime?: string;
  updateTime?: string;
}

/**
 * API 分页响应
 */
export interface StyleListApiResponse {
  status: number;
  success: boolean;
  message: string;
  data: {
    total: number;
    pageNum: number;
    pageSize: number;
    records: StyleRecord[];
  };
}

/**
 * API 详情响应
 */
export interface StyleDetailApiResponse {
  status: number;
  success: boolean;
  message: string;
  data: StyleRecord;
}

/**
 * 分页响应（内部使用）
 */
export interface StyleListResponse {
  records: StyleRecord[];
  total: number;
  pageNum: number;
  pageSize: number;
}

/**
 * 风格表单数据
 */
export interface StyleFormData {
  styleName: string;
  styleNameJa: string;
  styleOrder: number;
  styleImage: string;
  status: StyleStatus;
  description: string;
  descriptionJa: string;
  limitTime: number;
  model: number | string;
  isSelfStyle: number;
  styleTypeId: number;
  defaultSelected: number;
  modelNameSuffix?: string;
  modelType?: number; // 子模型：1-flus，2-sdxl（仅 model===5 时有效）
  isRecommend?: number;
  recommendSort?: number;
  workFlowJson?: string;
  pixel: number;
  gcoins?: number;
  pcoins?: number;
  isVipStyle?: number;
  minTierLevel?: number; // E15: 最低会员等级
  supportStep?: number;
  stepMin?: number;
  stepMax?: number;
  stepDefault?: number;
  support4k?: number;
  supportLora?: number;
  supportInpaint?: number;
  inpaintWorkflowId?: string;
}

/**
 * 模型选项（/artworkAiDrawStyle/models 返回：model 为字符串 "3"|"5"|"6"|"7"）
 */
export interface ModelOption {
  model: string;
  name: string;
}

/**
 * 风格类型选项
 */
export interface StyleTypeOption {
  styleTypeId: number;
  styleType: string;
  styleTypeJa?: string;
}

